module.exports = __webpack_public_path__ + "static/img/ajax-loading.49963fe.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global/img/ajax-loading.gif
// module id = 562
// module chunks = 31